module.exports = __webpack_public_path__ + "static/media/british-accent-logo.1b652322.svg";